// React & Hooks
import React, { useEffect, useRef, useState } from "react";

// Third-party Libraries
import Quill from "quill";
import "quill/dist/quill.snow.css";
import axios from "axios";

// Components
import { BackButton } from "../common/back-button/back-button";
import FileUpload from "./file-upload";

// API / Config
import { ENDPOINTS } from "../../js/api/_config";
import { uploadKnowledgeBase } from "../../js/api/trials-file-upload";

const PatientScreening = ({ trialId, addToast }) => {
  const [text, setText] = useState("Default value");
  const [files, setFiles] = useState([]);
  const [apiFiles, setApiFiles] = useState([]);
  const editorRef = useRef(null);
  const quillInstance = useRef(null);

  const fetchData = async () => {
    try {
      const result = await axios.get(
        `${ENDPOINTS.TRIALS.GET_PATIENT_SCREENING}?trialID=${trialId}`
      );
      if (result.data.success) {
        quillInstance.current.root.innerHTML = result.data.data.value;
      }
    } catch (error) {
    } finally {
      //setLoading(false); // Set loading to false after the API call
    }
  };

  useEffect(() => {
    if (editorRef.current) {
      quillInstance.current = new Quill(editorRef.current, {
        theme: "snow", // or 'bubble'
        placeholder: "Write something ...",
      });
    }
  }, []);
  const fetchFiles = async () => {
    try {
      const response = await axios.get(
        ENDPOINTS.WORKFLOW.GET_KNOWLEDGE_BASE_FILES,
        {
          params: { trialID: trialId },
        }
      );

      if (response?.data) {
        setApiFiles(response.data.data);
      } else {
        addToast("No files found for this trial.", "info");
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      addToast("Failed to fetch files. Please try again.", "error");
    }
  };

  useEffect(() => {
    fetchFiles();
  }, [trialId]);

  useEffect(() => {
    if (trialId) {
      fetchData();
    }
  }, [trialId]);

  const saveChanges = async (toast) => {
    try {
      const result = await axios.put(
        `${ENDPOINTS.TRIALS.UPDATE_PATIENT_SCREENING}`,
        {
          trialID: trialId,
          patientScreening: quillInstance.current.root.innerHTML,
        }
      );
      if (result.data.success) {
        if (toast === "file") {
          addToast("File has been uploaded successfully", "success");
        } else {
          addToast(
            "Patient screening information has been updated successfully",
            "success"
          );
        }
      }
    } catch (error) {
    } finally {
      //setLoading(false); // Set loading to false after the API call
    }
  };

  const saveFilesAndData = () => {
    files.length > 0
      ? uploadKnowledgeBase(trialId, files)
          .then(() => {
            setFiles([]);
            return fetchFiles();
          })
          .then(() => {
            saveChanges('file');
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 413) {
                 addToast(
                "File size is too large. Please upload smaller files.",
                "error"
              );
              } else {
                 addToast(
                `Upload failed with status: ${error.response.status}`,
                "error"
              );
              }
            } else if (error.request) {
              console.error("No response received:", error.request);
              addToast(
                "Upload failed: the file might be too large for the server limit.",
                "error"
              );
            } else {
              console.error("Error setting up request:", error.message);
              addToast(
                `Unexpected error: ${error.message}`,
                "error"
              );
            }
          })
      : saveChanges();
  };

  useEffect(() => {
    console.log("files test", files);
    console.log("files test apiFiles", apiFiles);
    console.log("files test trialId", trialId);
  }, [files, apiFiles]);

  return (
    <>
      <div className="h-[calc(100vh-244px)] overflow-y-auto p-5 pt-0 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
        <p className="font-medium mb-5">Trial Knowledge Base</p>
        <FileUpload
          files={files}
          setFiles={setFiles}
          apiFiles={apiFiles}
          trialID={trialId}
          fetchFiles={fetchFiles}
        />
        <div>
          <p className="font-medium mb-5">Trial General Info</p>
          <div className="w-[calc(50vw-245px)] mb-[100px]">
            <div ref={editorRef} style={{ height: "300px" }} />
          </div>
        </div>
      </div>

      <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-4 bottom-0 w-full bg-white pl-8 flex gap-5">
        <button
          onClick={() => {
            saveFilesAndData();
          }}
          className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]"
        >
          Save
        </button>
        <BackButton editTrial={true} />
      </div>
    </>
  );
};

export default PatientScreening;
